import React from 'react';

interface TimerWarningModalProps {
  isVisible: boolean;
  timeRemaining: number;
  onDismiss: () => void;
}

const TimerWarningModal: React.FC<TimerWarningModalProps> = ({
  isVisible,
  timeRemaining,
  onDismiss
}) => {
  if (!isVisible) return null;

  const formatTime = (seconds: number): string => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`;
  };

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 9999
    }}>
      <div style={{
        backgroundColor: 'white',
        borderRadius: '8px',
        padding: '24px',
        maxWidth: '400px',
        width: '90%',
        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.3)',
        textAlign: 'center'
      }}>
        <div style={{
          fontSize: '18px',
          fontWeight: 'bold',
          color: '#d32f2f',
          marginBottom: '16px'
        }}>
          ⏰ Time Running Out!
        </div>
        
        <div style={{
          fontSize: '16px',
          color: '#333',
          marginBottom: '20px'
        }}>
          Your session will expire in <strong>{formatTime(timeRemaining)}</strong>
        </div>
        
        <div style={{
          fontSize: '14px',
          color: '#666',
          marginBottom: '24px',
          lineHeight: 1.4
        }}>
          Please complete your appointment booking or your session will be reset.
        </div>
        
        <button
          onClick={onDismiss}
          style={{
            backgroundColor: '#1976d2',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            padding: '12px 24px',
            fontSize: '16px',
            fontWeight: 'bold',
            cursor: 'pointer',
            width: '100%'
          }}
        >
          Continue Booking
        </button>
      </div>
    </div>
  );
};

export default TimerWarningModal;
